var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradCapSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.747,
    height: 41.557,
    viewBox: "0 0 64.747 41.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2590",
    "data-name": "Rect\\xE1ngulo 2590",
    width: 64.747,
    height: 41.557,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6648",
    "data-name": "Grupo 6648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6647",
    "data-name": "Grupo 6647",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5433",
    "data-name": "Trazado 5433",
    d: "M32.938,44.057a108.35,108.35,0,0,1-14.217-.824c-5.04-.7-7-1.638-7-3.331V19.879A1.385,1.385,0,0,1,13.6,18.585l19.342,7.368,19.342-7.368a1.385,1.385,0,0,1,1.879,1.294V39.9c0,1.693-1.964,2.627-7,3.331a108.359,108.359,0,0,1-14.217.824M14.489,39.439c1.427.714,7.656,1.849,18.449,1.849s17.022-1.135,18.45-1.849V21.889L33.432,28.729a1.388,1.388,0,0,1-.987,0L14.489,21.889Z",
    transform: "translate(-2.462 -3.886)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5434",
    "data-name": "Trazado 5434",
    d: "M30.476,24.936a1.376,1.376,0,0,1-.493-.092L.892,13.763a1.386,1.386,0,0,1,0-2.589L29.983.091a1.388,1.388,0,0,1,.987,0L60.06,11.173a1.386,1.386,0,0,1,0,2.589L30.97,24.844a1.384,1.384,0,0,1-.494.092M5.277,12.468l25.2,9.6,25.2-9.6-25.2-9.6Z",
    transform: "translate(0 0)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5435",
    "data-name": "Trazado 5435",
    d: "M67.673,26.5a1.386,1.386,0,0,1-1.385-1.385V16.8H39.967a1.385,1.385,0,0,1,0-2.771H67.673a1.385,1.385,0,0,1,1.385,1.385v9.7A1.386,1.386,0,0,1,67.673,26.5",
    transform: "translate(-8.106 -2.948)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5436",
    "data-name": "Trazado 5436",
    d: "M74.033,47.084a5.179,5.179,0,0,1-5.16-5.649l1-11.042a4.156,4.156,0,0,1,8.311,0l1,11.042a5.18,5.18,0,0,1-5.159,5.649m0-18.008a1.387,1.387,0,0,0-1.385,1.385,1.115,1.115,0,0,1-.006.126l-1.009,11.1a2.41,2.41,0,1,0,4.8,0l-1.009-11.1c0-.042-.006-.084-.006-.126a1.387,1.387,0,0,0-1.385-1.385",
    transform: "translate(-14.466 -5.527)",
    fill: "#fc5145"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCapSvg);
export default __webpack_public_path__ + "static/media/Grad-cap-svg.b3b2721815f575bf068dc21320d89658.svg";
export { ForwardRef as ReactComponent };